<template>
  <div class="wjTaskManageList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="gardenId" @change="selectHouse">
            <el-option v-for="(item,index) in gardenList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 楼号单元号房间号 暂时关闭 -->
        <!-- <el-form-item>
          <el-select v-model="houseId" @change="selectUnit">
            <el-option key :label="$t('lang.lab_selectBuildingNum')" value='0'></el-option>
            <el-option
              v-for="(item,index) in houseList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="unitId" @change="selectRoom">
            <el-option key :label="$t('lang.lab_selectUnitNum')" value="0"></el-option>
            <el-option
              v-for="(item,index) in unitList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="roomId">
            <el-option key :label="$t('lang.lab_selectRoomNum')" value="0"></el-option>
            <el-option
              v-for="(item,index) in roomList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        // 打开此处代码时，记得删除下边的myLaunch
        <el-form-item>
          <el-checkbox v-model="myLaunch">{{$t('lang.lab_myLaunch')}}</el-checkbox>
        </el-form-item>
        <br/> -->
        <el-form-item>
          <el-select v-model="maintainOneId" @change="selectSecond">
            <el-option key :label="$t('lang.lab_maintainOne')" value="0"></el-option>
            <el-option v-for="(item,index) in maintainOneList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="maintainTwoId" @change="selectThird">
            <el-option key :label="$t('lang.lab_maintainTwo')" value="0"></el-option>
            <el-option v-for="(item,index) in maintainTwoList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="maintainThreeId" @change="selectForth">
            <el-option key :label="$t('lang.lab_maintainThree')" value="0"></el-option>
            <el-option v-for="(item,index) in maintainThreeList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
				<!-- <el-form-item>
          <el-select v-model="maintainFourId" @change="selectFifth">
            <el-option key :label="$t('lang.lab_maintainFour')" value="0"></el-option>
            <el-option v-for="(item,index) in maintainFourList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-select v-model="maintainFiveId">
            <el-option key :label="$t('lang.lab_maintainFive')" value="0"></el-option>
            <el-option v-for="(item,index) in maintainFiveList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
				
        <el-form-item>
          <el-select v-model="state">
            <el-option key :label="$t('lang.lab_states')" value=""></el-option>
            <el-option v-for="(item,index) in statelist" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input :placeholder="$t('lang.pla_inputKeyword')" v-model="keyword"></el-input>
        </el-form-item>
        <!-- myLaunch 由我发起 -->
        <el-form-item>
          <el-checkbox v-model="myLaunch">{{$t('lang.lab_myLaunch')}}</el-checkbox>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addTask')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="this.taskManageListcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="gardenName" :label="$t('lang.lab_gardenName')"></el-table-column>
        <el-table-column prop="name" :label="$t('lang.lab_compoundName')"></el-table-column>
        <el-table-column prop="typeName1" :label="$t('lang.lab_typeName1')"></el-table-column>
        <el-table-column prop="typeName2" :label="$t('lang.lab_typeName2')"></el-table-column>
        <el-table-column prop="content" :label="$t('lang.lab_taskContent')" width="180px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.content }}
                </span>
              </div>
              <div>
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createPersonName" :label="$t('lang.lab_isCreatePersonName')" width="180px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.createPersonName&&scope.row.createPersonName.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.createPersonName }}
                </span>
              </div>
              <div>
                {{ scope.row.createPersonName.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span v-if="scope.row.createPersonName.length>require('@/config/enum').tableDatamaxlength10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.createPersonName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="dutyPersonName" :label="$t('lang.lab_isDutyPersonName')" width="180px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.dutyPersonName&&scope.row.dutyPersonName.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false">
              <div slot="content">
                <span>
                  {{ scope.row.dutyPersonName }}
                </span>
              </div>
              <div>
                {{ scope.row.dutyPersonName.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span v-if="scope.row.dutyPersonName.length>require('@/config/enum').tableDatamaxlength10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.dutyPersonName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" prop="operation"
          :width="require('@/config/enum').opr_width3">
          <template slot-scope="scope">
            <el-button v-if='scope.row.state === 0' @click="play(scope.row)">{{$t('lang.lab_taskPlay')}}</el-button>
            <el-button v-if='scope.row.state === 1' @click="pause(scope.row)">{{$t('lang.lab_taskPause')}}</el-button>
            <el-button @click="edit(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
  /**
   *@ClassName:taskManageList
   *@Description:任务管理
   *@author:宋莎
   *@Copyright:格众科技
   *@date:2020-04-26
   */
  export default {
    name: '/manage/main.wjTaskManageList',
    data() {
      return {
        gardenId: this.$store.getters.gardenId,
        multipleSelection: [], // 多选框
        gardenList: [], // 小区集合
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        type: 1, // 1:楼 2：单元 3：房间
        houseId: '0', // 楼层绑定值
        unitId: '0', // 单元绑定值
        roomId: '0', // 房间绑定值
        houseList: [], //  存储根据小区请求回来的楼号
        unitList: [], //  存储根据楼号请求回来的单元
        roomList: [], //  存储根据单元请求回来的房间号
        maintainType: 1, // 级别接口区分字段
        maintainOneId: '0', // 报事分类一级绑定值
        maintainTwoId: '0', // 报事分类二级绑定值
        maintainThreeId: '0', // 报事分类三级绑定值
        maintainFourId: '0', // 报事分类四级绑定值
        maintainFiveId: '0', // 报事分类五级绑定值
        maintainOneList: [], // 报事一级分类list
        maintainTwoList: [], // 报事二级分类list
        maintainThreeList: [], // 报事三级分类list
        maintainFourList: [], // 报事四级分类list
        maintainFiveList: [], // 报事五级分类list
        myLaunch: '', // 我发起的
        state: '', // 状态
        keyword: '', // 关键字
        tableData: [], // 列表数据
        statelist: this.$i18n.t('lang.TaskManageList_stateList'), // 状态
        taskManageListcheckbox: require('@/config/enum').taskManageListcheckbox, // 是否隐藏复选框
      }
    },
    created() {
      // #8449 add
      setTimeout(() => {
        window.localStorage.setItem('wjtaskManagementForm', '')
      }, 200)
      this.selectHouse()
      // 小区下拉
      this.gardens()
      // 报事一级下拉
      this.maintains()
      // 查询list
      this.getData()
    },
    activated() {
      this.selectHouse()
      // 小区下拉
      this.gardens()
      // 报事一级下拉
      this.maintains()
      // 查询list
      this.getData()
    },
    computed: {
      ...mapGetters({ userDataId: 'staffId', userGardenList: 'userGardenList' })
    },
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.selectHouse(newFlag)
        this.commit()
      }
    },
    methods: {
      // 获取数据
      getData() {
        var userId = ''
        console.log('')
        if (this.myLaunch === true) {
          userId = this.userDataId
         console.log(userId)
        }
        this.$get(
          `/quartzJob/?gardenId=${this.gardenId}&houseId=${this.houseId}&unitId=${this.unitId}&roomId=${this.roomId}&typeId1=${this.maintainOneId}&state=${this.state}&keyword=${this.keyword}&typeId2=${this.maintainTwoId}&typeId3=${this.maintainThreeId}&typeId4=${this.maintainFourId}&typeId5=${this.maintainFiveId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}&createPerson=${userId}`
          ).then(
          res => {
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 新增
      add() {
        window.localStorage.setItem('wjtaskManagementForm', '')
        this.$router.push({
          name: 'wjEditTask',
          query: {
            flag: false,
            isPatrol: 0
          }
        })
      },
      // 编辑
      edit(id) {
        window.localStorage.setItem('wjtaskManagementForm', '')
        this.$router.push({
          name: 'wjEditTask',
          query: {
            flag: true,
            id: id,
            isPatrol: 0
          }
        })
      },
      // 启动
      play(row) {
        var staffId = this.$store.getters.userData.id
        this.$confirm(
            this.$i18n.t('lang.lab_confirmPlay'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          )
          .then(() => {
            /* 超级管理员全权限 */
            if (staffId != 100006) {
              /* 登录账号与创建人不同 */
              if (row.createPerson != staffId) {
                this.$message({
                  type: 'success',
                  message: '只可操作自己创建的任务' /* this.$i18n.t('lang.lab_successPause') */
                })
              } else {
                this.$patch(`/playQuartzJob/` + row.id).then(
                  res => {
                    if (res && res.errCode === 0) {
                      this.$message({
                        type: 'success',
                        message: this.$i18n.t('lang.lab_successPlay')
                      })
                      this.getData()
                    }
                  },
                  error => {
                    if (error === null) {
                      this.$message.warning(this.$i18n.t('lang.lab_playError'))
                    } else {
                      this.$message.error(error)
                    }
                  }
                )
              }
            } else {
              this.$patch(`/playQuartzJob/` + row.id).then(
                res => {
                  if (res && res.errCode === 0) {
                    this.$message({
                      type: 'success',
                      message: this.$i18n.t('lang.lab_successPlay')
                    })
                    this.getData()
                  }
                },
                error => {
                  if (error === null) {
                    this.$message.warning(this.$i18n.t('lang.lab_playError'))
                  } else {
                    this.$message.error(error)
                  }
                }
              )
            }
          })
      },
      // 停止
      pause(row) {
        var staffId = this.$store.getters.userData.id
        this.$confirm(
            this.$i18n.t('lang.lab_confirmPause'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          )
          .then(() => {
            /* 超级管理员全权限 */
            if (staffId != 100006) {
              /* 登录账号与创建人不同 */
              if (row.createPerson != staffId) {
                this.$message({
                  type: 'success',
                  message: '只可操作自己创建的任务' /* this.$i18n.t('lang.lab_successPause') */
                })
              } else {
                this.$patch(`/pauseQuartzJob/` + row.id).then(
                  res => {
                    if (res && res.errCode === 0) {
                      this.$message({
                        type: 'success',
                        message: this.$i18n.t('lang.lab_successPause')
                      })
                      this.getData()
                    }
                  },
                  error => {
                    if (error === null) {
                      this.$message.warning(this.$i18n.t('lang.lab_pauseError'))
                    } else {
                      this.$message.error(error)
                    }
                  }
                )
              }
            } else {
              this.$patch(`/pauseQuartzJob/` + row.id).then(
                res => {
                  if (res && res.errCode === 0) {
                    this.$message({
                      type: 'success',
                      message: this.$i18n.t('lang.lab_successPause')
                    })
                    this.getData()
                  }
                },
                error => {
                  if (error === null) {
                    this.$message.warning(this.$i18n.t('lang.lab_pauseError'))
                  } else {
                    this.$message.error(error)
                  }
                }
              )
            }
          })
      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 删除
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          )
          .then(() => {
            this.$delete(`/quartzJob/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                if (error === null) {
                  this.$message.warning(this.$i18n.t('lang.lab_deleteError'))
                } else {
                  this.$message.error(error)
                }
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 获取小区下拉
      gardens() {
        let myGardens = [...this.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
          if (this.gardenId === 0) {
            let newValue = {
              id: 0,
              name: this.$i18n.t('lang.lab_isSelectCommunity')
            }
            myGardens.unshift(newValue)
          } else {
            let newValue = {
              id: 0,
              name: this.$i18n.t('lang.lab_allCommunity')
            }
            myGardens.unshift(newValue)
          }
        }
        this.gardenList = myGardens
      },
      // id查询楼号楼层房间号
      gardenGrids(id) {
        if (id === '0' || id === '' || id === 0) {
          return
        }
        this.$get(`/gardenGrids?type=${this.type}&pageSize=999&pageNo=1&parentId=${id}`).then(
          res => {
            if (res && res.errCode === 0) {
              if (this.type === 1) {
                this.houseList = res.list
              } else if (this.type === 2) {
                this.unitList = res.list
              } else if (this.type === 3) {
                this.roomList = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 通过小区选择楼号
      selectHouse() {
        this.type = 1
        this.unitList = []
        this.roomList = []
        this.houseList = []
        this.houseId = '0'
        this.unitId = '0'
        this.roomId = '0'
        this.gardenGrids(this.gardenId)
      },
      // 通过楼层选择单元号
      selectUnit() {
        this.type = 2
        this.unitList = []
        this.roomList = []
        this.unitId = '0'
        this.roomId = '0'
        this.gardenGrids(this.houseId)
      },
      // 通过单元选择房间号
      selectRoom() {
        this.type = 3
        this.roomList = []
        this.roomId = '0'
        this.gardenGrids(this.unitId)
      },
      // 报事服务分类
      maintains() {
        this.$get(
          `/maintainTypes?type=1&pageNo=1&pageSize=999&gardenId=${this.gardenId}`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              if (this.maintainType === 1) {
                this.maintainOneList = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 通过级别id查询下一级别list
      maintainTypes(id) {
        this.$get(`/maintainTypes?type=${this.maintainType}&Pid=${id}&pageNo=1&pageSize=999`).then(
          res => {
            if (res && res.errCode === 0) {
              if (this.maintainType === 2) {
                this.maintainTwoList = res.list
              } else if (this.maintainType === 3) {
                this.maintainThreeList = res.list
              } else if (this.maintainType === 4) {
                this.maintainFourList = res.list
              } else if (this.maintainType === 5) {
                this.maintainFiveList = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 通过一级别查询二级下拉list
      selectSecond() {
        this.maintainType = 2
        this.maintainTwoList = []
        this.maintainThreeList = []
        this.maintainFourList = []
        this.maintainFiveList = []
        this.maintainTwoId = '0'
        this.maintainThreeId = '0'
        this.maintainFourId = '0'
        this.maintainFiveId = '0'
        this.maintainTypes(this.maintainOneId)
      },
      // 通过二级别查询三级下拉list
      selectThird() {
        this.maintainType = 3
        this.maintainThreeList = []
        this.maintainFourList = []
        this.maintainFiveList = []
        this.maintainThreeId = '0'
        this.maintainFourId = '0'
        this.maintainFiveId = '0'
        this.maintainTypes(this.maintainTwoId)
      },
      // 通过三级别查询四级下拉list
			selectForth() {
				this.maintainType = 4
        this.maintainFourList = []
        this.maintainFiveList = []
        this.maintainFourId = '0'
        this.maintainFiveId = '0'
        this.maintainTypes(this.maintainThreeId)
			},
      // 通过四级别查询五级下拉list
			selectFifth() {
				this.maintainType = 5
        this.maintainFiveList = []
        this.maintainFiveId = '0'
        this.maintainTypes(this.maintainFourId)
			},
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    }
  }
</script>

<style lang="scss">
  .taskManageList {
    .blue {
      color: #4A88B0
    }
  }

  .el-tooltip__popper.is-light {
    max-width: 300px;
  }
</style>
